import React, {Component} from 'react';
import {Api} from '../../api';
import './ErrorPage.scss';
import connect from "react-redux/es/connect/connect";
import planeGIF from '../../../public/img/plane_animation.gif'
import ButtonInput from "../Common/ButtonInput";

class ErrorPage extends Component {
    state = {
        msg: '',
        token: '',
        isMailSent: false,
    };

    componentDidMount() {
        var msg = this.getQueryParams('msg', decodeURI(window.location.href));
        var token = this.getQueryParams('token', decodeURI(window.location.href));
        this.setState({msg: msg, token: token});
    }

    getQueryParams = (params, url) => {
        let href = url;
        //this expression is to get the query strings
        let reg = new RegExp('[?&]' + params + '=([^&#]*)', 'i');
        let queryString = reg.exec(href);
        return queryString ? queryString[1] : null;
    };

    sendEmailAgain = () => {
        this.setState({isLoading: true});
        Api.get(`user/resend_registration_token?token=${this.state.token}`).then((response) => {
            this.setState({isLoading: false});
            console.log(response, 'response resend email');
            if (response.data.status !== '409') {
                alert('email sent')
                this.setState({isMailSent: true})
            } else {
                alert(response.data.message)
            }
        }).catch((error) => {
            this.setState({isLoading: false});
            alert('error');
            console.log(error, 'error')
        });
    };

    render() {
        const {msg, isMailSent} = this.state;

        return (
            <div className="signup-popup token-invalid-page">
                <div className={'form-wrapper'}>
                    <header className="signup-popup__header">
                        <h3 className="signup-popup__second-title">{msg}</h3>
                    </header>

                    <div className='p-t-20 sent-email-body'>
                        {isMailSent ?
                            <div>
                                <div className="fields-row text-email-sent m-b-0">
                                    A confirmation email has been sent.
                                </div>
                                <div className="plane-gif">
                                    <img src={planeGIF} alt="Email sent"/>
                                </div>
                                <div className="fields-row text-something-wrong">
                                    Something wrong?
                                </div>
                                <div className="fields-row text-tips-email m-b-0">
                                    - I didn't receive the confirmation email:&nbsp;
                                    <span onClick={this.sendEmailAgain} className='password-link'>send again</span>!
                                </div>
                            </div> :
                            <div>
                                <ButtonInput
                                    id="next-button"
                                    className={'dark-button blue-button width-400 margin-25'}
                                    title='Send again'
                                    handleClick={(e) => this.sendEmailAgain()}/>
                            </div>
                        }

                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(ErrorPage);


// export default Landing;



// WEBPACK FOOTER //
// ./src/components/ErrorPage/ErrorPage.js